import { MessageOutlined } from "@ant-design/icons";
import { Popconfirm } from "antd";
import { memo } from "react";
import type { Comment } from "types/comment";
import { CommentAvatar, CommentComposer } from "./CommentComposer";
import { CommentFiles, commentTime, renderCommentContent } from "./commentView";

type CommentItemProps = {
  comment: Comment;
  code?: string;
  isReply?: boolean;
  canDelete: boolean;
  replyOpen: boolean;
  replyAvatar?: string;
  replyName: string;
  onToggleReply: () => void;
  onDelete: (commentId: number) => void;
  onReply: (payload: { content: string; files: Comment["files"]; mentionStaffIds: number[] }) => Promise<void>;
};

export const CommentItem = memo(({
  comment,
  code,
  isReply,
  canDelete,
  replyOpen,
  replyAvatar,
  replyName,
  onToggleReply,
  onDelete,
  onReply,
}: CommentItemProps) => {
  const staffName = comment.staff?.name || "Nhân viên";

  return (
    <article className={`commentThread__item${isReply ? " isReply" : ""}`}>
      <CommentAvatar avatar={comment.staff?.avatar} name={staffName} />
      <div className="commentThread__itemBody">
        <div className="commentThread__meta">
          <span className="commentThread__name">{staffName}</span>
          {code ? <span className="commentThread__code">{code}</span> : null}
          <span className="commentThread__time">{commentTime(comment.createdAt)}</span>
        </div>
        <div className="commentThread__bubble">
          {comment.content ? (
            <p className="commentThread__content">{renderCommentContent(comment.content, comment.mentionStaffs)}</p>
          ) : null}
          <CommentFiles files={comment.files} />
        </div>
        <div className="commentThread__itemActions">
          {!isReply && (
            <button type="button" className="commentThread__reply" onClick={onToggleReply}>
              <MessageOutlined />
              Trả lời
            </button>
          )}
          {canDelete && (
            <Popconfirm
              cancelText="Không"
              okText="Xóa"
              title="Xóa bình luận này?"
              onConfirm={() => onDelete(comment.id)}
            >
              <button type="button" className="commentThread__delete">Xóa</button>
            </Popconfirm>
          )}
        </div>
        {replyOpen && !isReply && (
          <CommentComposer
            avatar={replyAvatar}
            name={replyName}
            placeholder="Trả lời"
            submitLabel="Trả lời"
            onSubmit={onReply}
          />
        )}
      </div>
    </article>
  );
});

CommentItem.displayName = "CommentItem";
